import React, { useEffect, useState } from 'react';

import './styles.css';
import '../styles.css';

import close from '../../../assets/images/close.svg';
import br from '../../../assets/images/brazil.svg';
import sp from '../../../assets/images/sp.svg';
import rj from '../../../assets/images/rj.svg';

import LoadingComponent from '../../LoadingComponent';

import api from '../../../services/api';

const ModalRegion = ({ handleClose, handleRegion, handleShift }) => {
  const [regionais, setRegionais] = useState([]);
  const [loading, setLoading] = useState(true);

  const [icon] = useState({
    'br': br,
    'sp': sp,
    'rj': rj
  });
  useEffect(() => {
    getRegionais();
  }, []);

  const getRegionais = async () => {
    const { data } = await api.get(`list-regionais`);
    if (data) {
      setLoading(false);
      setRegionais(data.regionais);
    }
  }


  return (
    <div className="dash-modal">
      <div className="dash-modal-content sm">
        <button className="btn-close" onClick={handleClose}><img src={close} /></button>
        <div className="dash-modal-header">
          <h2 className="text-center">Escolha a região</h2>
        </div>
        <div className="dash-modal-body">
          {!loading &&
            <div className="btns-regions">
              {regionais.map((regional, key) => (
                <button key={key} onClick={() => {
                  handleRegion(regional);
                  handleClose();
                }} className="btn-region"><img src={icon[regional.slug]} /> {regional.nome}</button>
              ))}
            </div>
          }
          <LoadingComponent loading={loading} />
        </div>
      </div>
    </div>
  );

}

export default ModalRegion;